export const isExternalURL = (url: string) => {
  try {
    return new URL(url)?.origin !== window.location.origin;
  } catch {
    return false;
  }
};
